module.exports = __webpack_public_path__ + "static/media/1-3-1.362427e9.png";